var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 13.3333C10.2217 13.3333 12.8334 10.7216 12.8334 7.49996C12.8334 4.2783 10.2217 1.66663 7.00008 1.66663C3.77842 1.66663 1.16675 4.2783 1.16675 7.49996C1.16675 10.7216 3.77842 13.3333 7.00008 13.3333Z",
    stroke: "#005B99",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64993 5.8501L5.3501 9.14993",
    stroke: "#005B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3501 5.8501L8.64993 9.14993",
    stroke: "#005B99",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterRemove);
export default __webpack_public_path__ + "static/media/filter-remove.3f1231f4c6c62581bc29d9017a467d4e.svg";
export { ForwardRef as ReactComponent };